const getDateOfNextMonday = (date) => {
    const dateCopy = new Date(date); //.getTime()
    dateCopy.setHours(0,0,0,0);

    const nextMonday = new Date(
      dateCopy.setDate(
        dateCopy.getDate() + ((7 - dateCopy.getDay() + 1) % 7 || 7),
      ),
    );
  
    return nextMonday;
}

export default getDateOfNextMonday;